import { useTranslation } from 'react-i18next';
import AddGroupButton from './AddGroupButton';
import { SchoolYear } from '../context/MyGroupsContext';
import useGroups from '../hooks/useGroups';
import EmptyState from '../../../shared-components/EmptyState';

type Props = {
  schoolYear: SchoolYear;
};

function GroupsEmptyState({ schoolYear }: Props) {
  const { t } = useTranslation();

  const { onGroupsChange } = useGroups();

  if (schoolYear.hasPassed) {
    return (
      <EmptyState
        variant="list"
        headerTitle={t('PAGES.MY_GROUPS.LIST_GROUP.EMPTY.PREVIOUS_SCHOOLYEAR.TITLE')}
        bodyText={t('PAGES.MY_GROUPS.LIST_GROUP.EMPTY.PREVIOUS_SCHOOLYEAR.TEXT')}
      />
    );
  }

  if (schoolYear.isCurrent) {
    return (
      <EmptyState
        variant="list"
        headerTitle={t('PAGES.MY_GROUPS.LIST_GROUP.EMPTY.CURRENT_SCHOOLYEAR.TITLE')}
        bodyText={t('PAGES.MY_GROUPS.LIST_GROUP.EMPTY.CURRENT_SCHOOLYEAR.TEXT')}
        cta={<AddGroupButton schoolYear={schoolYear} onGroupsChange={onGroupsChange} size="md" />}
      />
    );
  }

  return (
    <EmptyState
      variant="list"
      headerTitle={t('PAGES.MY_GROUPS.LIST_GROUP.EMPTY.NEXT_SCHOOLYEAR.TITLE')}
      bodyText={t('PAGES.MY_GROUPS.LIST_GROUP.EMPTY.NEXT_SCHOOLYEAR.TEXT')}
      cta={<AddGroupButton schoolYear={schoolYear} onGroupsChange={onGroupsChange} size="md" />}
    />
  );
}

export default GroupsEmptyState;
